<script>
import { freightUnitType, deliveryTypes } from 'pando-constants';

const FreightTypeForFtlPtl = {
    methods: {
        freightTypeForFtlPtl(dataType){
            if(dataType == deliveryTypes.FTL){
                return this.contractTypes.find(({ id }) => id === freightUnitType.PER_TRIP);
            }else if(dataType == deliveryTypes.PTL){
                return this.contractTypes.find(({ id }) => id === freightUnitType.PER_KG);
            }
        }
    },
};

export default FreightTypeForFtlPtl;
</script>